import type { Vendor, VendorBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<Vendor, VendorBase>({
  tableName: "vendors",
  searchColumns: ["name", "contact_name", "contact_email"],
});

export class VendorService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static createMany = base.createMany;
  static update = base.update;
  static delete = base.delete;
}
